import { render, staticRenderFns } from "./CodettesFooter.vue?vue&type=template&id=445abd31&scoped=true"
import script from "./CodettesFooter.vue?vue&type=script&lang=js"
export * from "./CodettesFooter.vue?vue&type=script&lang=js"
import style0 from "./CodettesFooter.vue?vue&type=style&index=0&id=445abd31&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445abd31",
  null
  
)

export default component.exports